<template>
  <div class="mmBasicInfoDialog" @contextmenu.prevent="">
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogStatus"
      class="dialog"
      width="1400px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="closeMmDialog"
    > 
      <div class="navBorder"></div>
      <div class="main" :style="{ maxHeight: contentMaxHeight }">
        <div class="left">
          <el-col :span="8">
            <div class="leftItem">
              <p class="rightItemTitle popTitleDialog">ID**</p>
              <el-input
                class="popInput"
                v-model="toDialoPatientsData.id_in_hospital"
                :disabled="true"
                placeholder="请输入内容"
              ></el-input>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="leftItem">
              <p class="rightItemTitle popTitleDialog">姓名**</p>
              <el-input
                class="popInput"
                v-model="toDialoPatientsData.name"
                :disabled="true"
                placeholder="请输入内容"
              ></el-input>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="leftItem">
              <p class="rightItemTitle popTitleDialog">基线数据</p>
              <el-switch
                v-model="mmData.baseline"
                :active-value="1"
                :inactive-value="0"
                :disabled="isBaselineSwitchDisabled"
                active-color="#13ce66"
                @change="onBaselineChange"
              ></el-switch>
            </div>
          </el-col>

          <div v-for="(sectionData, section) in formData" :key="section" style="width:100%; margin-top:20px;">
            <el-col :span="24" :offset="0">
              <div class="popTitleDialog" style="width:100%; text-align:left; color:#4da3c0; margin-top:12px;"> {{ section }} <span class="section-stats">已填 {{ getSectionStats(sectionData).filled }}/{{ getSectionStats(sectionData).total }} &nbsp; &nbsp; {{ getSectionStats(sectionData).percent }}%</span></div>
              <div class="navBorder"></div>
            </el-col>
            
            <div v-for="(field,index) in sectionData" :key="field.name" class="form-field" :class="{'required-error': field.required && showValidation && !isFieldFilled(field.name), 'field-filled': isFieldFilled(field.name)}" v-show="!field.only_4_baseline || mmData.baseline===1 || baselineFieldsExpanded[section]">
            
              <el-col :span="6">
                <div class="leftItem">
                  <p class="rightItemTitle popTitleDialog">{{ field.label }}<span v-if="field.required" class="required-star">*</span>
                    <span v-if="isFieldFilled(field.name)" class="field-filled-badge">✓</span>
                  </p>
                  <el-input
                    v-if="field.type === 'input'"
                    type="text"
                    class="popInput"
                    v-model="mmData[field.name]"
                    :disabled="!isEdit"
                    :placeholder="field.placeholder"
                  ></el-input>

                  <el-input
                    v-else-if="field.type === 'number'"
                    type="number"
                    class="popInput"
                    v-model="mmData[field.name]"
                    :disabled="!isEdit"
                    :placeholder="field.placeholder"
                  ></el-input>

                  <el-date-picker
                    v-else-if="field.type === 'date'"
                    type="date"
                    class="popInput"
                    v-model="mmData[field.name]"
                    :disabled="!isEdit"
                    :placeholder="field.placeholder"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                  <!-- 下拉选择器 -->
                  <el-select   v-else-if="field.type === 'select'" 
                    :multiple="field.multiple"
                    placeholder="请选择" 
                    v-model="mmData[field.name]" 
                    class="popInput"
                    :disabled="!isEdit"
                  >
                    <el-option
                      v-for="option in sectionData[index].option"
                      :key="option.value"
                      :label="option.label"
                      :value="option.value"
                    > </el-option>
                  </el-select>

                </div>
              </el-col>
            </div>
            <el-col v-if="hasBaselineOnlyFields(sectionData) && mmData.baseline!==1" :span="24" style="text-align:center; margin: 4px 0;">
              <el-button type="text" @click="toggleBaselineFields(section)" style="color: #999; font-size: 13px;">
                <i :class="baselineFieldsExpanded[section] ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                {{ baselineFieldsExpanded[section] ? '收起基线专有字段' : '展开基线专有字段（非基线数据可忽略）' }}
              </el-button>
            </el-col>
          </div>

        </div>
        <div class="right">
          <div class="right-header">
            <span class="right-title">结构化病历信息提取</span>
            <el-button type="primary" size="small" :loading="jsonExtractLoading" @click="submitJSONExtract">{{ jsonExtractLoading ? '解析中...' : '开始智能解析' }}</el-button>
          </div>
          <div class="right-input-area">
            <el-input
              type="textarea"
              v-model="jsonExtractInput"
              placeholder="请输入病历文本，系统将自动提取结构化数据..."
              :rows="12"
              resize="none"
            ></el-input>
          </div>
          <div class="right-result-area">
            <div class="right-result-header">
              <span class="right-result-title">提取结果（JSON）</span>
              <el-button v-if="jsonExtractResult" type="success" size="mini" @click="applyExtractToForm">添加到表单</el-button>
            </div>
            <pre class="json-result">{{ jsonExtractResult }}</pre>
          </div>
        </div>
      </div>

      <!-- 底部按钮 -->
      <div slot="footer" class="dialog-footer" v-if="isEdit">
        <button
          class="btn iconfont leftItemSubmit"
          @click="submitMm"
          style="padding: 0"
        >{{submitText}}</button>
      </div>

    </el-dialog>
  </div>
</template>
<script>
import moment from "moment";
import addMMBasicInfo from "../gql/addMMBasicInfo.gql";
import getMMById from "../gql/getMMById.gql";
import setMMBasicInfo from "../gql/setMMBasicInfo.gql";
import getMmBaselineId from "../gql/getMmBaselineId.gql";
import extractMmJsonDataDeepseek from "../gql/extractMmJsonDataDeepseek.gql";

export default {
  name: 'MmBasicInfoDialog',
  data() {
    return {
      formData: {},
      
      mmData: {
        patient_id: "",
        visit_date: "",
        serial_number: "",
        xj_hosp_pathology_no: "",
        ajcc8_clinical_stage: "",
        ext_hosp_pathology_no: "",
        inpatient_id: "",
        time_of_dark_spot_discovery: "",
        initial_dark_spot_length: "",
        initial_dark_spot_width: "",
        brief_medical_history: "",
        intvl_spot_to_mm_dx_months: "",
        date_of_confirmed_diagnosis: "",
        prelim_clinical_diagnosis: "",
        primary_site: [],
        precise_location: "",
        nail_position: "",
        lesion_len_initial_tx: "",
        lesion_wid_initial_tx: "",
        nevus_malig_trans_status: "",
        surface_ulceration: "",
        hx_of_trauma_existence: "",
        hx_of_trauma_type: "",
        concomitant_diseases: [],
        date_of_first_surgery: "",
        institution_of_first_surgery: "",
        method_of_first_surgery: [],
        breslow_thick_first_surg: "",
        subsequent_surg_method: [],
        total_surg_cnt_local_5cm: "",
        preoperative_biopsy: "",
        other_treatment_history: [],
        earliest_meta_site: [],
        earliest_meta_time: "",
        current_metastasis_site: [],
        current_meta_discovery_time: "",
        sentinel_ln_positivity: "",
        adj_tx_chemo_status: "",
        adj_tx_chemo_months: "",
        adj_tx_radio_status: "",
        adj_tx_radio_count: "",
        ifn_alpha1b_initial_date: "",
        ifn_alpha1b_dosage_cycle: "",
        ifn_alpha1b_ae_fever: "",
        ifn_alpha1b_ae_max_temp: "",
        ifn_alpha1b_ae_duration: "",
        ifn_alpha1b_ae_subseq_fever: "",
        pd1_tx_initial_date: "",
        pd1_tx_dosage: "",
        pd1_tx_last_date: "",
        pd1_tx_total_count: "",
        tmz_anlotinib_date: "",
        tmz_anlotinib_dosage: "",
        tmz_anlotinib_last_date: "",
        tmz_anlotinib_cycle: "",
        viti_concomitant_class: "",
        viti_concomitant_onset_date: "",
        viti_concomitant_max_area: "",
        viti_concomitant_impr_date: "",
        lab_blood_routine_wbc: "",
        lab_blood_routine_rbc: "",
        lab_blood_routine_hb: "",
        lab_blood_routine_plt: "",
        lab_liver_func_alt: "",
        lab_liver_func_ast: "",
        lab_liver_func_tbil: "",
        lab_thyroid_imm_tsh: "",
        lab_thyroid_imm_antpo: "",
        lab_thyroid_imm_atg: "",
        lab_hormone_cortisol: "",
        gene_mol_indicators_tmb: "",
        gene_mol_indicators_msi: "",
        gene_mol_indicators_ewsr1_trans: "",
        gene_mol_indicators_braf: "",
        gene_mol_indicators_ckit: "",
        gene_mol_indicators_nras: "",
        gene_mol_indicators_pdl1: "",
        ihc_pathology_ulcer: "",
        ihc_pathology_s100: "",
        ihc_pathology_hmb45: "",
        ihc_pathology_prame: "",
        ihc_pathology_melana: "",
        ihc_pathology_sox10: "",
        ihc_pathology_ki67: "",
        ihc_pathology_phh3: "",
        ihc_patho_mitotic_index: "",
        ihc_pathology_ve1: "",
        ihc_patho_microsat_lesions: "",
        ihc_patho_intravasc_tumor: "",
        ihc_patho_lc_activity: "",
        dx_tx_records: "",
        baseline: 0,
        note1: "",
        create_time: "",
        update_time: ""
      },
      // Schema 中 Float/Int 类型的字段
      numberFields: [
        'initial_dark_spot_length', 'initial_dark_spot_width', 'intvl_spot_to_mm_dx_months',
        'lesion_len_initial_tx', 'lesion_wid_initial_tx', 'breslow_thick_first_surg',
        'total_surg_cnt_local_5cm', 'adj_tx_chemo_months', 'adj_tx_radio_count',
        'ifn_alpha1b_ae_max_temp', 'pd1_tx_total_count',
        'lab_blood_routine_wbc', 'lab_blood_routine_rbc', 'lab_blood_routine_hb', 'lab_blood_routine_plt',
        'lab_liver_func_alt', 'lab_liver_func_ast', 'lab_liver_func_tbil',
        'lab_thyroid_imm_tsh', 'lab_hormone_cortisol', 'baseline'
      ],
      dateFields: [
        'visit_date', 'time_of_dark_spot_discovery', 'date_of_confirmed_diagnosis',
        'date_of_first_surgery', 'earliest_meta_time', 'current_meta_discovery_time',
        'ifn_alpha1b_initial_date', 'pd1_tx_initial_date', 'pd1_tx_last_date',
        'tmz_anlotinib_date', 'tmz_anlotinib_last_date',
        'viti_concomitant_onset_date', 'viti_concomitant_impr_date',
        'create_time', 'update_time'
      ],
      // Schema mutation 中不支持的字段（仅在UI显示，不提交）
      excludeFields: ['create_time', 'update_time'],

      submitText: "新增记录",
      addMmId: -1,
      isRefreshHandler: false,
      existingBaselineId: null, // 从后端获取的该患者已有基线记录id，null表示无基线
      baselineFieldsExpanded: {}, // 非基线数据时，各section独立控制是否展开基线专有字段
      showValidation: false, // 是否显示必填校验
      jsonExtractInput: "", // AI提取用的输入文本
      jsonExtractLoading: false, // AI提取加载状态
      jsonExtractResult: "", // AI提取结果（格式化JSON展示）
      jsonExtractedData: null, // AI提取结果（原始解析数据，用于"添加到表单"）
    };
  },
  computed: {
    dialogStatus: {
      get() {
        if (this.isShowMm) {
          this.resetData();
          this.fetchExistingBaselineId();
        }
        return this.isShowMm;
      },
      set(val) {
        this.$emit("setMmStatus", val);
      }
    },
    dialogTitle(){
      let dialogTitle = "黑色素瘤诊疗记录";
      if(this.mmData.visit_date){
        dialogTitle = dialogTitle + "--" + this.mmData.visit_date;
      }
      return dialogTitle;
    },
    contentMaxHeight() {
      const maxHeight = window.innerHeight * 0.8 - 100;
      return `${maxHeight}px`;
    },
    isBaselineSwitchDisabled() {
      if (!this.isEdit) return true;
      if (this.existingBaselineId !== null) {
        // 已有基线记录：只有当前编辑的就是基线记录本身时才允许操作
        if (this.openMmId && Number(this.openMmId) === this.existingBaselineId) {
          return false;
        }
        return true;
      }
      return false; // 没有基线记录时，任何记录都可以设置
    }
  },
  watch: {
    async 'openMmId'(newVal) {
      if (newVal) {
        this.submitText = "修改记录";
        await this.getMmById(Number(newVal));
        this.addMmId = Number(newVal);
      } else {
        this.resetData();
        this.submitText = "新增记录";
      }
    }
  },
  props: {
    isShowMm: {
      type: Boolean,
      default: () => false
    },
    toDialoPatientsData: {
      type: Object
    },
    openMmId: {
      type: Number,
      default: () => null
    },
    isEdit: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    async fetchExistingBaselineId() {
      try {
        let res = await this.$apollo.query({
          query: getMmBaselineId,
          fetchPolicy: "no-cache",
          variables: { patient_id: Number(this.toDialoPatientsData.id) }
        });
        this.existingBaselineId = res.data.getMmBaselineId;
      } catch (error) {
        this.existingBaselineId = null;
      }
    },
    onBaselineChange(val) {
      if (val === 0) {
        // 关闭基线标记，弹出确认
        this.$confirm('取消基线标记后该患者将没有基线数据，确认？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 用户确认关闭
        }).catch(() => {
          // 用户取消，恢复为1
          this.mmData.baseline = 1;
        });
      }
    },
    closeMmDialog() {
      if (this.isRefreshHandler) {
        this.$emit('refreshHandler', Number(this.toDialoPatientsData.id));
      }
      this.addMmId = -1;
      this.isRefreshHandler = false;
      this.baselineFieldsExpanded = {};
      this.showValidation = false;
      this.jsonExtractInput = "";
      this.jsonExtractLoading = false;
      this.jsonExtractResult = "";
      this.jsonExtractedData = null;
    },
    resetData() {
      this.baselineFieldsExpanded = {};
      this.showValidation = false;
      this.jsonExtractInput = "";
      this.jsonExtractLoading = false;
      this.jsonExtractResult = "";
      this.jsonExtractedData = null;
      this.mmData = {
        patient_id: Number(this.toDialoPatientsData.id),
        visit_date: "",
        serial_number: "",
        xj_hosp_pathology_no: "",
        ajcc8_clinical_stage: "",
        ext_hosp_pathology_no: "",
        inpatient_id: "",
        time_of_dark_spot_discovery: "",
        initial_dark_spot_length: "",
        initial_dark_spot_width: "",
        brief_medical_history: "",
        intvl_spot_to_mm_dx_months: "",
        date_of_confirmed_diagnosis: "",
        prelim_clinical_diagnosis: "",
        primary_site: [],
        precise_location: "",
        nail_position: "",
        lesion_len_initial_tx: "",
        lesion_wid_initial_tx: "",
        nevus_malig_trans_status: "",
        surface_ulceration: "",
        hx_of_trauma_existence: "",
        hx_of_trauma_type: "",
        concomitant_diseases: [],
        date_of_first_surgery: "",
        institution_of_first_surgery: "",
        method_of_first_surgery: [],
        breslow_thick_first_surg: "",
        subsequent_surg_method: [],
        total_surg_cnt_local_5cm: "",
        preoperative_biopsy: "",
        other_treatment_history: [],
        earliest_meta_site: [],
        earliest_meta_time: "",
        current_metastasis_site: [],
        current_meta_discovery_time: "",
        sentinel_ln_positivity: "",
        adj_tx_chemo_status: "",
        adj_tx_chemo_months: "",
        adj_tx_radio_status: "",
        adj_tx_radio_count: "",
        ifn_alpha1b_initial_date: "",
        ifn_alpha1b_dosage_cycle: "",
        ifn_alpha1b_ae_fever: "",
        ifn_alpha1b_ae_max_temp: "",
        ifn_alpha1b_ae_duration: "",
        ifn_alpha1b_ae_subseq_fever: "",
        pd1_tx_initial_date: "",
        pd1_tx_dosage: "",
        pd1_tx_last_date: "",
        pd1_tx_total_count: "",
        tmz_anlotinib_date: "",
        tmz_anlotinib_dosage: "",
        tmz_anlotinib_last_date: "",
        tmz_anlotinib_cycle: "",
        viti_concomitant_class: "",
        viti_concomitant_onset_date: "",
        viti_concomitant_max_area: "",
        viti_concomitant_impr_date: "",
        lab_blood_routine_wbc: "",
        lab_blood_routine_rbc: "",
        lab_blood_routine_hb: "",
        lab_blood_routine_plt: "",
        lab_liver_func_alt: "",
        lab_liver_func_ast: "",
        lab_liver_func_tbil: "",
        lab_thyroid_imm_tsh: "",
        lab_thyroid_imm_antpo: "",
        lab_thyroid_imm_atg: "",
        lab_hormone_cortisol: "",
        gene_mol_indicators_tmb: "",
        gene_mol_indicators_msi: "",
        gene_mol_indicators_ewsr1_trans: "",
        gene_mol_indicators_braf: "",
        gene_mol_indicators_ckit: "",
        gene_mol_indicators_nras: "",
        gene_mol_indicators_pdl1: "",
        ihc_pathology_ulcer: "",
        ihc_pathology_s100: "",
        ihc_pathology_hmb45: "",
        ihc_pathology_prame: "",
        ihc_pathology_melana: "",
        ihc_pathology_sox10: "",
        ihc_pathology_ki67: "",
        ihc_pathology_phh3: "",
        ihc_patho_mitotic_index: "",
        ihc_pathology_ve1: "",
        ihc_patho_microsat_lesions: "",
        ihc_patho_intravasc_tumor: "",
        ihc_patho_lc_activity: "",
        dx_tx_records: "",
        baseline: this.existingBaselineId === null ? 1 : 0,
        note1: "",
        create_time: "",
        update_time: ""
      };
    },
    async getMmById(id) {
      try {
        let res = await this.$apollo.query({
          query: getMMById,
          fetchPolicy: "no-cache",
          variables: { id }
        });
        let data = res.data.mmBasicInfo;
        for(let key in this.mmData){
          if(this.numberFields.includes(key)){
            if(data[key]===-1 || data[key]===null){
              this.mmData[key] = '';
            }else{
              this.mmData[key] = Number(data[key]);
            }
          }else if(this.dateFields.includes(key)){
            if(data[key] && data[key] !== -30610253143000){
              const formatted = moment(data[key]).format("YYYY-MM-DD");
              this.mmData[key] = formatted === '1000-01-01' ? '' : formatted;
            }else{
              this.mmData[key] = "";
            }
          } else{
            this.mmData[key] = this.transformStr2Array(key, data[key] || '');
          }
        }
      } catch (error) {
        this.$message.error("数据获取失败");
        this.$emit("setMmStatus", false);
      }
    },
    // 判断该字段是否是 select-multiple，将逗号分隔字符串转为数组
    transformStr2Array(key, inputStr){
      let matched = false;
      for(let sectionName in this.formData){
        for(let form of this.formData[sectionName]){
          if(form.name===key && form.multiple===true){
            matched = true;
            break;
          }
        }
        if(matched) break;
      }
      if(matched){
        let str = (inputStr || '').trim();
        if(str.endsWith(',')){
          str = str.slice(0, -1);
        }
        if(str==='') return [];
        return str.split(',').filter(item => item !== '');
      }else{
        return inputStr;
      }
    },
    // 将数组转为逗号分隔字符串
    transformArray2Str(key, array){
      let matched = false;
      for(let sectionName in this.formData){
        for(let form of this.formData[sectionName]){
          if(form.name===key && form.multiple===true){
            matched = true;
            break;
          }
        }
        if(matched) break;
      }
      if(matched){
        return array.join(',');
      }else{
        return array;
      }
    },
    async submitMm() {
      if (!this.validateRequired()) return;
      if (this.openMmId) {
        console.log("修改黑色素瘤，id=", this.openMmId);
        await this.setMm();
      } else {
        console.log("新增黑色素瘤");
        await this.addMm();
      }
    },
    async addMm() {
      if (this.addMmId > -1) {
        this.$message.error("已经新增了黑色素瘤信息");
        return;
      }
      if (!this.validateNegativeNumbers()) return;
      try {
        let obj = {};
        for(const key in this.mmData){
          if(this.excludeFields.includes(key)) continue;
          if(this.mmData[key]===undefined || this.mmData[key]===null || this.mmData[key]===''){
            if(this.dateFields.includes(key)){
              obj[key] = "1000-01-01 00:00:00";
            }
            continue;
          }else{
            if(this.numberFields.includes(key)){
              obj[key] = Number(this.mmData[key]);
            }else if(this.dateFields.includes(key)){
              obj[key] = this.mmData[key]
            }else if(Array.isArray(this.mmData[key])){
              if(this.mmData[key].length > 0){
                obj[key] = this.mmData[key].join(',');
              }
            } else{
              obj[key] = this.mmData[key];
            }
          }  
        }     
        obj.patient_id = Number(this.toDialoPatientsData.id);
        console.log("新增黑色素瘤，数据=", obj);
        const res = await this.$apollo.mutate({
          mutation: addMMBasicInfo,
          variables: obj
        });
        this.addMmId = res.data.addMMBasicInfo.id;
        this.$message.success("数据已保存");
        this.isRefreshHandler = true;
      } catch (error) {
        this.$message.error("保存失败");
      }
    },
    async setMm() {
      if (!this.validateNegativeNumbers()) return;
      try {
        let obj = {};
        for(const key in this.mmData){
          if(this.excludeFields.includes(key)) continue;
          if(this.mmData[key]===undefined || this.mmData[key]===null || this.mmData[key]===''){
            if(this.dateFields.includes(key)){
              obj[key] = "1000-01-01 00:00:00";
            }
            continue;
          }else{
            if(this.numberFields.includes(key)){
              obj[key] = Number(this.mmData[key]);
            }else if(this.dateFields.includes(key)){
              obj[key] = this.mmData[key]
            }else if(Array.isArray(this.mmData[key])){
              if(this.mmData[key].length > 0){
                obj[key] = this.mmData[key].join(',');
              }
            } else{
              obj[key] = this.mmData[key];
            }
          }          
        }
        obj.id = this.openMmId;
        obj.patient_id = Number(this.toDialoPatientsData.id);
        console.log("修改黑色素瘤，id=", this.openMmId, "，数据=", obj);
        await this.$apollo.mutate({
          mutation: setMMBasicInfo,
          variables: obj
        });
        this.$message.success("数据已保存");
        this.isRefreshHandler = true;
        this.$emit('refreshHandler1', {
          id: this.openMmId
        });
        this.$emit('setMmStatus', false);
      } catch (error) {
        this.$message.error("保存失败");
      }
    },

    isFieldFilled(fieldName) {
      const val = this.mmData[fieldName];
      if (val === null || val === undefined) return false;
      if (Array.isArray(val)) return val.length > 0;
      if (typeof val === 'string') return val.trim() !== '';
      if (typeof val === 'number') return val !== -1;
      return true;
    },
    getSectionStats(sectionData) {
      const total = sectionData.length;
      const filled = sectionData.filter(f => this.isFieldFilled(f.name)).length;
      const percent = total > 0 ? Math.round(filled / total * 100) : 0;
      return { total, filled, percent };
    },
    hasBaselineOnlyFields(sectionData) {
      return sectionData.some(f => f.only_4_baseline === true);
    },
    toggleBaselineFields(section) {
      this.$set(this.baselineFieldsExpanded, section, !this.baselineFieldsExpanded[section]);
    },
    async submitJSONExtract() {
      if (!this.jsonExtractInput || !this.jsonExtractInput.trim()) {
        this.$message.warning("请先输入需要提取的文本内容");
        return;
      }
      this.jsonExtractLoading = true;
      try {
        const message = this.mmJsonPrompt(this.jsonExtractInput);
        const res = await this.$apollo.mutate({
          mutation: extractMmJsonDataDeepseek,
          variables: { message }
        });
        const rawResult = res.data.extractMmJsonDataDeepseek;
        if (!rawResult) {
          this.$message.error("AI未返回有效数据");
          return;
        }
        console.log("Deepseek JSON match:", rawResult);
        // 尝试解析JSON字符串
        let extractedData;
        try {
          extractedData = JSON.parse(rawResult);
        } catch (e) {
          // 尝试从返回文本中提取JSON部分
          const jsonMatch = rawResult.match(/\[[\s\S]*\]/);
          console.log("Deepseek JSON match:", jsonMatch);
          if (jsonMatch) {
            extractedData = JSON.parse(jsonMatch[0]);
          } else {
            this.$message.error("AI返回数据格式无法解析");
            return;
          }
        }
        // 按非空优先排序后存储格式化JSON到右侧结果展示区
        const sortedData = this.sortExtractedData(extractedData);
        this.jsonExtractResult = JSON.stringify(sortedData, null, 2);
        // 存储原始解析数据，等用户点击"添加到表单"后再赋值
        this.jsonExtractedData = extractedData;
        this.$message.success("AI数据提取成功，请点击\"添加到表单\"将结果填入表单");
      } catch (error) {
        console.error("AI提取失败:", error);
        this.$message.error("AI数据提取失败，请重试");
      } finally {
        this.jsonExtractLoading = false;
      }
    },
    applyExtractToForm() {
      if (!this.jsonExtractedData) {
        this.$message.warning("没有可添加的提取数据");
        return;
      }
      const extractedData = this.jsonExtractedData;
      let filledCount = 0;
      if (Array.isArray(extractedData)) {
        for (const item of extractedData) {
          const key = item.keyword || item.name;
          const value = item.value;
          if (key && value !== undefined && value !== null && value !== '') {
            const isArrayField = this.isMultipleSelectField(key);
            if (isArrayField) {
              if (Array.isArray(value)) {
                this.$set(this.mmData, key, value);
                filledCount++;
              } else if (typeof value === 'string') {
                this.$set(this.mmData, key, value.split(',').filter(v => v));
                filledCount++;
              }
            } else {
              this.$set(this.mmData, key, value);
              filledCount++;
            }
          }
        }
      } else if (typeof extractedData === 'object') {
        for (const key in extractedData) {
          const value = extractedData[key];
          if (value !== undefined && value !== null && value !== '') {
            const isArrayField = this.isMultipleSelectField(key);
            if (isArrayField) {
              if (Array.isArray(value)) {
                this.$set(this.mmData, key, value);
                filledCount++;
              } else if (typeof value === 'string') {
                this.$set(this.mmData, key, value.split(',').filter(v => v));
                filledCount++;
              }
            } else {
              this.$set(this.mmData, key, value);
              filledCount++;
            }
          }
        }
      }
      this.$message.success(`已将 ${filledCount} 个字段添加到表单`);
    },
    sortExtractedData(data) {
      // 判断值是否为空
      const isEmpty = (v) => v === undefined || v === null || v === '' || (Array.isArray(v) && v.length === 0);
      if (Array.isArray(data)) {
        // 数组格式：[{keyword, value}, ...] 非空排前
        return [...data].sort((a, b) => {
          const aEmpty = isEmpty(a.value) ? 1 : 0;
          const bEmpty = isEmpty(b.value) ? 1 : 0;
          return aEmpty - bEmpty;
        });
      } else if (typeof data === 'object' && data !== null) {
        // 对象格式：{key: value, ...} 非空排前
        const entries = Object.entries(data);
        entries.sort((a, b) => {
          const aEmpty = isEmpty(a[1]) ? 1 : 0;
          const bEmpty = isEmpty(b[1]) ? 1 : 0;
          return aEmpty - bEmpty;
        });
        const sorted = {};
        for (const [key, value] of entries) {
          sorted[key] = value;
        }
        return sorted;
      }
      return data;
    },
    isMultipleSelectField(key) {
      for (const sectionName in this.formData) {
        for (const form of this.formData[sectionName]) {
          if (form.name === key && form.multiple === true) {
            return true;
          }
        }
      }
      return false;
    },
    validateNegativeNumbers() {
      for (const key of this.numberFields) {
        const val = this.mmData[key];
        if (val !== '' && val !== null && val !== undefined && Number(val) < 0) {
          // 查找对应的 label
          let label = key;
          for (const section in this.formData) {
            for (const field of this.formData[section]) {
              if (field.name === key) {
                label = field.label;
                break;
              }
            }
          }
          this.$message.error(`"${label}" 不允许输入负值`);
          return false;
        }
      }
      return true;
    },
    validateRequired() {
      const missingLabels = [];
      for (const section in this.formData) {
        for (const field of this.formData[section]) {
          if (field.required && !this.isFieldFilled(field.name)) {
            missingLabels.push(field.label);
          }
        }
      }
      if (missingLabels.length > 0) {
        this.showValidation = true;
        this.$message.error(`必填字段未填写：${missingLabels.join('、')}`);
        return false;
      }
      this.showValidation = false;
      return true;
    },
    genForms(){
      let formData = {
        "基本信息": [
          {
            "label": "接诊时间",
            "name": "visit_date",
            "type": "date",
            "placeholder": "请选择接诊时间",
            "required": true
          },
          {
            "label": "编号",
            "name": "serial_number",
            "type": "input",
            "placeholder": "请输入编号（M开头）",
            "required": true
          },
          {
            "label": "西京医院病理号",
            "name": "xj_hosp_pathology_no",
            "type": "input",
            "placeholder": "请输入西京医院病理号"
          },
          {
            "label": "AJCC8临床分期",
            "name": "ajcc8_clinical_stage",
            "type": "input",
            "placeholder": "请输入AJCC8临床分期",
            "required": true
          },
          {
            "label": "其它医院病理号",
            "name": "ext_hosp_pathology_no",
            "type": "input",
            "placeholder": "请输入其它医院病理号"
          },
          {
            "label": "住院号",
            "name": "inpatient_id",
            "type": "input",
            "placeholder": "请输入住院号"
          }

        ],
        "病史与诊断": [
          {
            "label": "发现黑斑时间",
            "name": "time_of_dark_spot_discovery",
            "type": "date",
            "placeholder": "请选择发现黑斑时间（年/月）",
            "only_4_baseline": true
          },
          {
            "label": "最初黑斑长度",
            "name": "initial_dark_spot_length",
            "type": "number",
            "placeholder": "请输入最初黑斑长度（cm）",
            "only_4_baseline": true
          },
          {
            "label": "最初黑斑宽度",
            "name": "initial_dark_spot_width",
            "type": "number",
            "placeholder": "请输入最初黑斑宽度（cm）",
            "only_4_baseline": true
          },
          {
            "label": "简要病史",
            "name": "brief_medical_history",
            "type": "input",
            "placeholder": "请输入简要病史",
            "only_4_baseline": true
          },
          {
            "label": "出现黑斑至诊断黑素瘤时间（月）",
            "name": "intvl_spot_to_mm_dx_months",
            "type": "number",
            "placeholder": "请输入出现黑斑至诊断黑素瘤时间（月）",
            "only_4_baseline": true
          },
          {
            "label": "确诊年月",
            "name": "date_of_confirmed_diagnosis",
            "type": "date",
            "placeholder": "请选择确诊年月",
            "only_4_baseline": true
          },
          {
            "label": "临床初步诊断",
            "name": "prelim_clinical_diagnosis",
            "type": "select",
            "placeholder": "请选择临床初步诊断",
            "only_4_baseline": true,
            "option": [
              { "label": "", "id": 0, "value": "" },
              { "label": "黑素瘤", "id": 1, "value": "黑素瘤" },
              { "label": "恶性雀斑样痣", "id": 2, "value": "恶性雀斑样痣" },
              { "label": "色痣恶变", "id": 3, "value": "色痣恶变" },
              { "label": "色痣(含甲母痣)", "id": 4, "value": "色痣(含甲母痣)" },
              { "label": "脂溢性角化病", "id": 5, "value": "脂溢性角化病" },
              { "label": "基癌", "id": 6, "value": "基癌" },
              { "label": "其它", "id": 7, "value": "其它" },
              { "label": "以往曾诊断", "id": 8, "value": "以往曾诊断" }
            ],
            "required": true
          },
          {
            "label": "原发部位",
            "name": "primary_site",
            "type": "select",
            "multiple": true,
            "placeholder": "请选择原发部位",
            "only_4_baseline": true,
            "option": [
              { "label": "", "id": 0, "value": "" },
              { "label": "不明", "id": 0, "value": "不明" },
              { "label": "手", "id": 1, "value": "手" },
              { "label": "足", "id": 2, "value": "足" },
              { "label": "头面颈", "id": 3, "value": "头面颈" },
              { "label": "四肢", "id": 4, "value": "四肢" },
              { "label": "躯干", "id": 5, "value": "躯干" },
              { "label": "口鼻黏膜", "id": 6, "value": "口鼻黏膜" },
              { "label": "外阴", "id": 7, "value": "外阴" },
              { "label": "肛肠", "id": 8, "value": "肛肠" },
              { "label": "眼", "id": 9, "value": "眼" }
            ],
            "required": true
          },
          {
            "label": "精确部位",
            "name": "precise_location",
            "type": "input",
            "placeholder": "请输入精确部位",
            "only_4_baseline": true
          },
          {
            "label": "指甲部位",
            "name": "nail_position",
            "type": "select",
            "placeholder": "请选择指甲部位",
            "only_4_baseline": true,
            "option": [
              { "label": "", "id": 0, "value": "" },
              { "label": "不是甲部", "id": 0, "value": "不是甲部" },
              { "label": "右足", "id": 1, "value": "右足" },
              { "label": "左足", "id": 2, "value": "左足" },
              { "label": "右手", "id": 3, "value": "右手" },
              { "label": "左手", "id": 4, "value": "左手" }
            ]
          },
          {
            "label": "初治疗时皮损长度",
            "name": "lesion_len_initial_tx",
            "type": "number",
            "placeholder": "请输入初治疗时皮损长度（cm）",
            "only_4_baseline": true
          },
          {
            "label": "初治疗时皮损宽度",
            "name": "lesion_wid_initial_tx",
            "type": "number",
            "placeholder": "请输入初治疗时皮损宽度（cm）",
            "only_4_baseline": true
          },
          {
            "label": "痣恶变情况",
            "name": "nevus_malig_trans_status",
            "type": "select",
            "placeholder": "请选择痣恶变情况",
            "only_4_baseline": true,
            "option": [
              { "label": "", "id": 0, "value": "" },
              { "label": "否", "id": 0, "value": "否" },
              { "label": "后天痣", "id": 1, "value": "后天痣" },
              { "label": "先天小痣", "id": 2, "value": "先天小痣" },
              { "label": "巨痣", "id": 3, "value": "巨痣" },
              { "label": "其它", "id": 4, "value": "其它" }
            ]
          },
          {
            "label": "表面溃破",
            "name": "surface_ulceration",
            "type": "select",
            "placeholder": "请选择表面溃破",
            "only_4_baseline": true,
            "option": [
              { "label": "", "id": 0, "value": "" },
              { "label": "有", "id": 1, "value": "有" },
              { "label": "无", "id": 2, "value": "无" }
            ]
          },
          {
            "label": "外伤史-是否存在",
            "name": "hx_of_trauma_existence",
            "type": "select",
            "placeholder": "请选择外伤史是否存在",
            "only_4_baseline": true,
            "option": [
              { "label": "", "id": 0, "value": "" },
              { "label": "有", "id": 1, "value": "有" },
              { "label": "无", "id": 2, "value": "无" }
            ]
          },
          {
            "label": "外伤史-外伤类型",
            "name": "hx_of_trauma_type",
            "type": "input",
            "placeholder": "请输入外伤类型",
            "only_4_baseline": true
          },
          {
            "label": "伴随疾病",
            "name": "concomitant_diseases",
            "type": "select",
            "multiple": true,
            "placeholder": "请选择伴随疾病",
            "only_4_baseline": true,
            "option": [
              { "label": "", "id": 0, "value": "" },
              { "label": "无", "id": 0, "value": "无" },
              { "label": "糖尿病", "id": 1, "value": "糖尿病" },
              { "label": "高血压", "id": 2, "value": "高血压" },
              { "label": "心脏病", "id": 3, "value": "心脏病" },
              { "label": "其它", "id": 4, "value": "其它" }
            ]
          }
        ],
        "手术与治疗史": [
          {
            "label": "首次手术时间",
            "name": "date_of_first_surgery",
            "type": "date",
            "placeholder": "请选择首次手术时间（年/月）",
            "only_4_baseline": true
          },
          {
            "label": "首次手术单位",
            "name": "institution_of_first_surgery",
            "type": "select",
            "placeholder": "请选择首次手术单位",
            "option": [
              { "label": "", "id": 0, "value": "" },
              { "label": "西京皮肤科", "id": 1, "value": "西京皮肤科" },
              { "label": "西京整形科", "id": 2, "value": "西京整形科" },
              { "label": "西京其它科", "id": 3, "value": "西京其它科" },
              { "label": "院外", "id": 4, "value": "院外" }
            ]
          },
          {
            "label": "首次手术方式",
            "name": "method_of_first_surgery",
            "type": "select",
            "multiple": true,
            "placeholder": "请选择首次手术方式",
            "option": [
              { "label": "", "id": 0, "value": "" },
              { "label": "截指/肢", "id": 1, "value": "截指/肢" },
              { "label": "扩大切除", "id": 2, "value": "扩大切除" },
              { "label": "转移灶切除", "id": 3, "value": "转移灶切除" },
              { "label": "淋巴结切除", "id": 4, "value": "淋巴结切除" },
              { "label": "淋巴结清扫", "id": 5, "value": "淋巴结清扫" },
              { "label": "切除未扩大", "id": 6, "value": "切除未扩大" }
            ]
          },
          {
            "label": "首次手术Breslow厚度",
            "name": "breslow_thick_first_surg",
            "type": "number",
            "placeholder": "请输入首次手术Breslow厚度（mm）"
          },
          {
            "label": "再次术式",
            "name": "subsequent_surg_method",
            "type": "select",
            "multiple": true,
            "placeholder": "请选择再次术式",
            "option": [
              { "label": "", "id": 0, "value": "" },
              { "label": "截指/肢", "id": 1, "value": "截指/肢" },
              { "label": "扩大切除", "id": 2, "value": "扩大切除" },
              { "label": "再扩大切除", "id": 3, "value": "再扩大切除" },
              { "label": "转移灶切除", "id": 4, "value": "转移灶切除" },
              { "label": "淋巴结切除", "id": 5, "value": "淋巴结切除" },
              { "label": "淋巴结清扫", "id": 6, "value": "淋巴结清扫" }
            ]
          },
          {
            "label": "局部5cm内手术总次数",
            "name": "total_surg_cnt_local_5cm",
            "type": "number",
            "placeholder": "请输入局部5cm内手术总次数"
          },
          {
            "label": "术前活检",
            "name": "preoperative_biopsy",
            "type": "select",
            "placeholder": "请选择术前活检",
            "option": [
              { "label": "", "id": 0, "value": "" },
              { "label": "否", "id": 0, "value": "否" },
              { "label": "是", "id": 1, "value": "是" }
            ]
          },
          {
            "label": "其它治疗史",
            "name": "other_treatment_history",
            "type": "select",
            "multiple": true,
            "placeholder": "请选择其它治疗史",
            "option": [
              { "label": "", "id": 0, "value": "" },
              { "label": "无", "id": 0, "value": "无" },
              { "label": "激光治疗", "id": 1, "value": "激光治疗" },
              { "label": "自已乱治", "id": 2, "value": "自已乱治" },
              { "label": "放疗", "id": 3, "value": "放疗" },
              { "label": "化疗", "id": 4, "value": "化疗" },
              { "label": "其它", "id": 5, "value": "其它" }
            ]
          },
          {
            "label": "最早发现转移部位",
            "name": "earliest_meta_site",
            "type": "select",
            "multiple": true,
            "placeholder": "请选择最早发现转移部位",
            "option": [
              { "label": "", "id": 0, "value": "" },
              { "label": "无", "id": 0, "value": "无" },
              { "label": "淋巴结", "id": 1, "value": "淋巴结" },
              { "label": "肝", "id": 2, "value": "肝" },
              { "label": "肺", "id": 3, "value": "肺" },
              { "label": "其它", "id": 4, "value": "其它" }
            ]
          },
          {
            "label": "最早发现转移时间",
            "name": "earliest_meta_time",
            "type": "date",
            "placeholder": "请选择最早发现转移时间（年/月）"
          },
          {
            "label": "现在转移部位",
            "name": "current_metastasis_site",
            "type": "select",
            "multiple": true,
            "placeholder": "请选择现在转移部位",
            "option": [
              { "label": "", "id": 0, "value": "" },
              { "label": "无", "id": 0, "value": "无" },
              { "label": "淋巴结", "id": 1, "value": "淋巴结" },
              { "label": "肝", "id": 2, "value": "肝" },
              { "label": "肺", "id": 3, "value": "肺" },
              { "label": "其它", "id": 4, "value": "其它" }
            ]
          },
          {
            "label": "现在转移发现时间",
            "name": "current_meta_discovery_time",
            "type": "date",
            "placeholder": "请选择现在转移发现时间（年/月）"
          },
          {
            "label": "前哨淋巴结阳性",
            "name": "sentinel_ln_positivity",
            "type": "select",
            "placeholder": "请选择前哨淋巴结阳性",
            "option": [
              { "label": "", "id": 0, "value": "" },
              { "label": "否", "id": 0, "value": "否" },
              { "label": "是", "id": 1, "value": "是" }
            ]
          },
          {
            "label": "辅助治疗-化疗-状态",
            "name": "adj_tx_chemo_status",
            "type": "select",
            "placeholder": "请选择辅助治疗-化疗-状态",
            "option": [
              { "label": "", "id": 0, "value": "" },
              { "label": "否", "id": 0, "value": "否" },
              { "label": "西京", "id": 1, "value": "西京" },
              { "label": "院外", "id": 2, "value": "院外" }
            ]
          },
          {
            "label": "辅助治疗-化疗-月数",
            "name": "adj_tx_chemo_months",
            "type": "number",
            "placeholder": "请输入辅助治疗-化疗-月数"
          },
          {
            "label": "辅助治疗-放疗-状态",
            "name": "adj_tx_radio_status",
            "type": "select",
            "placeholder": "请选择辅助治疗-放疗-状态",
            "option": [
              { "label": "", "id": 0, "value": "" },
              { "label": "否", "id": 0, "value": "否" },
              { "label": "西京", "id": 1, "value": "西京" },
              { "label": "院外", "id": 2, "value": "院外" }
            ]
          },
          {
            "label": "辅助治疗-放疗-次数",
            "name": "adj_tx_radio_count",
            "type": "number",
            "placeholder": "请输入辅助治疗-放疗-次数"
          }
        ],
        "药物治疗-干扰素-α1b": [
          {
            "label": "首次日期",
            "name": "ifn_alpha1b_initial_date",
            "type": "date",
            "placeholder": "请选择干扰素-α1b首次日期"
          },
          {
            "label": "剂量周期",
            "name": "ifn_alpha1b_dosage_cycle",
            "type": "input",
            "placeholder": "请输入干扰素-α1b剂量周期（μg/月）"
          },
          {
            "label": "不良反应-发热",
            "name": "ifn_alpha1b_ae_fever",
            "type": "select",
            "placeholder": "请选择干扰素-α1b不良反应-发热",
            "option": [
              { "label": "", "id": 0, "value": "" },
              { "label": "无", "id": 0, "value": "无" },
              { "label": "有", "id": 1, "value": "有" }
            ]
          },
          {
            "label": "不良反应最高体温",
            "name": "ifn_alpha1b_ae_max_temp",
            "type": "number",
            "placeholder": "请输入干扰素-α1b不良反应最高体温（℃）"
          },
          {
            "label": "不良反应持续时间",
            "name": "ifn_alpha1b_ae_duration",
            "type": "input",
            "placeholder": "请输入干扰素-α1b不良反应持续时间（h）"
          },
          {
            "label": "不良反应后续发热情况",
            "name": "ifn_alpha1b_ae_subseq_fever",
            "type": "input",
            "placeholder": "请输入干扰素-α1b不良反应后续发热情况"
          }
        ],
        "药物治疗-PD-1": [
          {
            "label": "首次日期",
            "name": "pd1_tx_initial_date",
            "type": "date",
            "placeholder": "请选择PD-1治疗首次日期"
          },
          {
            "label": "治疗剂量",
            "name": "pd1_tx_dosage",
            "type": "input",
            "placeholder": "请输入PD-1治疗剂量（mg）"
          },
          {
            "label": "治疗末次日期",
            "name": "pd1_tx_last_date",
            "type": "date",
            "placeholder": "请选择PD-1治疗末次日期"
          },
          {
            "label": "治疗总次数",
            "name": "pd1_tx_total_count",
            "type": "number",
            "placeholder": "请输入PD-1治疗总次数"
          }
        ],
        "药物治疗-TMZ/安罗替尼": [  
          {
            "label": "日期",
            "name": "tmz_anlotinib_date",
            "type": "date",
            "placeholder": "请选择TMZ/安罗替尼日期"
          },
          {
            "label": "剂量",
            "name": "tmz_anlotinib_dosage",
            "type": "input",
            "placeholder": "请输入TMZ/安罗替尼剂量（mg）"
          },
          {
            "label": "末次日期",
            "name": "tmz_anlotinib_last_date",
            "type": "date",
            "placeholder": "请选择TMZ/安罗替尼末次日期"
          },
          {
            "label": "周期",
            "name": "tmz_anlotinib_cycle",
            "type": "input",
            "placeholder": "请输入TMZ/安罗替尼周期（月）"
          }
        ],
        "共病（白癜风)": [
          {
            "label": "白癜风伴随分类",
            "name": "viti_concomitant_class",
            "type": "select",
            "placeholder": "请选择白癜风伴随分类",
            "option": [
              { "label": "", "id": 0, "value": "" },
              { "label": "患瘤前", "id": 1, "value": "患瘤前" },
              { "label": "治疗月开始", "id": 2, "value": "治疗月开始" }
            ],
            "only_4_baseline": true
          },
          {
            "label": "白癜风伴随首发日期",
            "name": "viti_concomitant_onset_date",
            "type": "date",
            "placeholder": "请选择白癜风伴随首发日期（年/月）"
          },
          {
            "label": "白癜风伴随最重面积",
            "name": "viti_concomitant_max_area",
            "type": "input",
            "placeholder": "请输入白癜风伴随最重面积（手掌数）"
          },
          {
            "label": "白癜风伴随好转日期",
            "name": "viti_concomitant_impr_date",
            "type": "date",
            "placeholder": "请选择白癜风伴随好转日期（年/月）"
          }
        ],
        "化验结果-血常规": [
          {
            "label": "血常规WBC",
            "name": "lab_blood_routine_wbc",
            "type": "number",
            "placeholder": "请输入血常规WBC"
          },
          {
            "label": "血常规RBC",
            "name": "lab_blood_routine_rbc",
            "type": "number",
            "placeholder": "请输入血常规RBC"
          },
          {
            "label": "血常规HB",
            "name": "lab_blood_routine_hb",
            "type": "number",
            "placeholder": "请输入血常规HB"
          },
          {
            "label": "血常规Plt",
            "name": "lab_blood_routine_plt",
            "type": "number",
            "placeholder": "请输入血常规Plt"
          }
        ],
        "化验结果-肝功/甲功": [
          {
            "label": "肝功ALT",
            "name": "lab_liver_func_alt",
            "type": "number",
            "placeholder": "请输入肝功ALT"
          },
          {
            "label": "肝功AST",
            "name": "lab_liver_func_ast",
            "type": "number",
            "placeholder": "请输入肝功AST"
          },
          {
            "label": "肝功TBIL",
            "name": "lab_liver_func_tbil",
            "type": "number",
            "placeholder": "请输入肝功TBIL"
          },
          {
            "label": "甲功/免疫TSH",
            "name": "lab_thyroid_imm_tsh",
            "type": "number",
            "placeholder": "请输入甲功/免疫TSH"
          },
          {
            "label": "甲功/免疫antpo",
            "name": "lab_thyroid_imm_antpo",
            "type": "input",
            "placeholder": "请输入甲功/免疫antpo"
          },
          {
            "label": "甲功/免疫atg",
            "name": "lab_thyroid_imm_atg",
            "type": "input",
            "placeholder": "请输入甲功/免疫atg"
          },
          {
            "label": "激素皮质醇",
            "name": "lab_hormone_cortisol",
            "type": "number",
            "placeholder": "请输入激素皮质醇"
          }
        ],
        "化验结果-基因与分子指标": [
          {
            "label": "TMB",
            "name": "gene_mol_indicators_tmb",
            "type": "input",
            "placeholder": "请输入基因与分子指标TMB"
          },
          {
            "label": "MSI",
            "name": "gene_mol_indicators_msi",
            "type": "input",
            "placeholder": "请输入基因与分子指标MSI"
          },
          {
            "label": "EWSR1易位",
            "name": "gene_mol_indicators_ewsr1_trans",
            "type": "input",
            "placeholder": "请输入基因与分子指标EWSR1易位"
          },
          {
            "label": "B-raf（%）",
            "name": "gene_mol_indicators_braf",
            "type": "input",
            "placeholder": "请输入基因与分子指标B-raf（%）"
          },
          {
            "label": "C-Kit（%）",
            "name": "gene_mol_indicators_ckit",
            "type": "input",
            "placeholder": "请输入基因与分子指标C-Kit（%）"
          },
          {
            "label": "N-Ras（%）",
            "name": "gene_mol_indicators_nras",
            "type": "input",
            "placeholder": "请输入基因与分子指标N-Ras（%）"
          },
          {
            "label": "PD-L1（%）",
            "name": "gene_mol_indicators_pdl1",
            "type": "input",
            "placeholder": "请输入基因与分子指标PD-L1（%）"
          }
        ],
        "免疫组化与病理": [
          {
            "label": "溃疡",
            "name": "ihc_pathology_ulcer",
            "type": "input",
            "placeholder": "请输入免疫组化与病理溃疡"
          },
          {
            "label": "S100",
            "name": "ihc_pathology_s100",
            "type": "input",
            "placeholder": "请输入免疫组化与病理S100"
          },
          {
            "label": "HMB45",
            "name": "ihc_pathology_hmb45",
            "type": "input",
            "placeholder": "请输入免疫组化与病理HMB45"
          },
          {
            "label": "Prame",
            "name": "ihc_pathology_prame",
            "type": "input",
            "placeholder": "请输入免疫组化与病理Prame"
          },
          {
            "label": "MelanA",
            "name": "ihc_pathology_melana",
            "type": "input",
            "placeholder": "请输入免疫组化与病理MelanA"
          },
          {
            "label": "SOX10",
            "name": "ihc_pathology_sox10",
            "type": "input",
            "placeholder": "请输入免疫组化与病理SOX10"
          },
          {
            "label": "Ki-67（%）",
            "name": "ihc_pathology_ki67",
            "type": "input",
            "placeholder": "请输入免疫组化与病理Ki-67（%）"
          },
          {
            "label": "PHH3",
            "name": "ihc_pathology_phh3",
            "type": "input",
            "placeholder": "请输入免疫组化与病理PHH3"
          },
          {
            "label": "核分裂指数",
            "name": "ihc_patho_mitotic_index",
            "type": "input",
            "placeholder": "请输入免疫组化与病理核分裂指数"
          },
          {
            "label": "VE-1",
            "name": "ihc_pathology_ve1",
            "type": "input",
            "placeholder": "请输入免疫组化与病理VE-1"
          },
          {
            "label": "微卫星灶",
            "name": "ihc_patho_microsat_lesions",
            "type": "input",
            "placeholder": "请输入免疫组化与病理微卫星灶"
          },
          {
            "label": "管腔内瘤",
            "name": "ihc_patho_intravasc_tumor",
            "type": "input",
            "placeholder": "请输入免疫组化与病理管腔内瘤"
          },
          {
            "label": "LC活跃度",
            "name": "ihc_patho_lc_activity",
            "type": "select",
            "placeholder": "请选择免疫组化与病理LC活跃度",
            "option": [
              { "label": "", "id": 0, "value": "" },
              { "label": "活跃", "id": 1, "value": "活跃" },
              { "label": "不活跃", "id": 2, "value": "不活跃" }
            ]
          }
        ],
        "其他": [
          {
            "label": "诊疗记录",
            "name": "dx_tx_records",
            "type": "input",
            "placeholder": "请输入诊疗记录（关键治疗过程、转移瘤B超、CT、MR、PET/CT、副反应、处理措施）"
          },
          {
            "label": "备注1",
            "name": "note1",
            "type": "input",
            "placeholder": "请输入备注1"
          }
        ]
      };
      return formData;
    },
    mmJsonPrompt(text){
      if(text.length<10){
        // 弹出消息提示
        this.$message.error('输入内容过短，请至少输入10个字');
        return;
      }
      if(text.length > 2000){
        text = text.slice(0, 2000);
        this.$message.warning('输入内容过长，已截取前2000个字');        
      }
      let role = "你是一个资深的皮肤科医生，负责收集和整理黑色素瘤患者的临床数据。";
      let message = "数据的标准化格式如下： [{'label': '接诊时间', 'keyword': 'visit_date', 'type': 'date', 'placeholder': '请选择接诊时间'}, {'label': '编号', 'keyword': 'serial_number', 'type': 'input', 'placeholder': '请输入编号（M开头）'}, {'label': '西京医院病理号', 'keyword': 'xj_hosp_pathology_no', 'type': 'input', 'placeholder': '请输入西京医院病理号'}, {'label': 'AJCC8临床分期', 'keyword': 'ajcc8_clinical_stage', 'type': 'input', 'placeholder': '请输入AJCC8临床分期'}, {'label': '其它医院病理号', 'keyword': 'ext_hosp_pathology_no', 'type': 'input', 'placeholder': '请输入其它医院病理号'}, {'label': '住院号', 'keyword': 'inpatient_id', 'type': 'input', 'placeholder': '请输入住院号'}, {'label': '发现黑斑时间', 'keyword': 'time_of_dark_spot_discovery', 'type': 'date', 'placeholder': '请选择发现黑斑时间（年/月）'}, {'label': '最初黑斑长度', 'keyword': 'initial_dark_spot_length', 'type': 'number', 'placeholder': '请输入最初黑斑长度（cm）'}, {'label': '最初黑斑宽度', 'keyword': 'initial_dark_spot_width', 'type': 'number', 'placeholder': '请输入最初黑斑宽度（cm）'}, {'label': '简要病史', 'keyword': 'brief_medical_history', 'type': 'input', 'placeholder': '请输入简要病史'}, {'label': '出现黑斑至诊断黑素瘤时间（月）', 'keyword': 'intvl_spot_to_mm_dx_months', 'type': 'number', 'placeholder': '请输入出现黑斑至诊断黑素瘤时间（月）'}, {'label': '确诊年月', 'keyword': 'date_of_confirmed_diagnosis', 'type': 'date', 'placeholder': '请选择确诊年月'}, {'label': '临床初步诊断', 'keyword': 'prelim_clinical_diagnosis', 'type': 'select', 'placeholder': '请选择临床初步诊断', 'option': [{'label': '', 'value': ''}, {'label': '黑素瘤', 'value': '黑素瘤'}, {'label': '恶性雀斑样痣', 'value': '恶性雀斑样痣'}, {'label': '色痣恶变', 'value': '色痣恶变'}, {'label': '色痣(含甲母痣)', 'value': '色痣(含甲母痣)'}, {'label': '脂溢性角化病', 'value': '脂溢性角化病'}, {'label': '基癌', 'value': '基癌'}, {'label': '其它', 'value': '其它'}, {'label': '以往曾诊断', 'value': '以往曾诊断'}]}, {'label': '原发部位', 'keyword': 'primary_site', 'type': 'select', 'placeholder': '请选择原发部位', 'option': [{'label': '', 'value': ''}, {'label': '不明', 'value': '不明'}, {'label': '手', 'value': '手'}, {'label': '足', 'value': '足'}, {'label': '头面颈', 'value': '头面颈'}, {'label': '四肢', 'value': '四肢'}, {'label': '躯干', 'value': '躯干'}, {'label': '口鼻黏膜', 'value': '口鼻黏膜'}, {'label': '外阴', 'value': '外阴'}, {'label': '肛肠', 'value': '肛肠'}, {'label': '眼', 'value': '眼'}]}, {'label': '精确部位', 'keyword': 'precise_location', 'type': 'input', 'placeholder': '请输入精确部位'}, {'label': '指甲部位', 'keyword': 'nail_position', 'type': 'select', 'placeholder': '请选择指甲部位', 'option': [{'label': '', 'value': ''}, {'label': '不是甲部', 'value': '不是甲部'}, {'label': '右足', 'value': '右足'}, {'label': '左足', 'value': '左足'}, {'label': '右手', 'value': '右手'}, {'label': '左手', 'value': '左手'}]}, {'label': '初治疗时皮损长度', 'keyword': 'lesion_len_initial_tx', 'type': 'number', 'placeholder': '请输入初治疗时皮损长度（cm）'}, {'label': '初治疗时皮损宽度', 'keyword': 'lesion_wid_initial_tx', 'type': 'number', 'placeholder': '请输入初治疗时皮损宽度（cm）'}, {'label': '痣恶变情况', 'keyword': 'nevus_malig_trans_status', 'type': 'select', 'placeholder': '请选择痣恶变情况', 'option': [{'label': '', 'value': ''}, {'label': '否', 'value': '否'}, {'label': '后天痣', 'value': '后天痣'}, {'label': '先天小痣', 'value': '先天小痣'}, {'label': '巨痣', 'value': '巨痣'}, {'label': '其它', 'value': '其它'}]}, {'label': '表面溃破', 'keyword': 'surface_ulceration', 'type': 'select', 'placeholder': '请选择表面溃破', 'option': [{'label': '', 'value': ''}, {'label': '有', 'value': '有'}, {'label': '无', 'value': '无'}]}, {'label': '外伤史-是否存在', 'keyword': 'hx_of_trauma_existence', 'type': 'select', 'placeholder': '请选择外伤史是否存在', 'option': [{'label': '', 'value': ''}, {'label': '有', 'value': '有'}, {'label': '无', 'value': '无'}]}, {'label': '外伤史-外伤类型', 'keyword': 'hx_of_trauma_type', 'type': 'input', 'placeholder': '请输入外伤类型'}, {'label': '伴随疾病', 'keyword': 'concomitant_diseases', 'type': 'select', 'placeholder': '请选择伴随疾病', 'option': [{'label': '', 'value': ''}, {'label': '无', 'value': '无'}, {'label': '糖尿病', 'value': '糖尿病'}, {'label': '高血压', 'value': '高血压'}, {'label': '心脏病', 'value': '心脏病'}, {'label': '其它', 'value': '其它'}]}, {'label': '首次手术时间', 'keyword': 'date_of_first_surgery', 'type': 'date', 'placeholder': '请选择首次手术时间（年/月）'}, {'label': '首次手术单位', 'keyword': 'institution_of_first_surgery', 'type': 'select', 'placeholder': '请选择首次手术单位', 'option': [{'label': '', 'value': ''}, {'label': '西京皮肤科', 'value': '西京皮肤科'}, {'label': '西京整形科', 'value': '西京整形科'}, {'label': '西京其它科', 'value': '西京其它科'}, {'label': '院外', 'value': '院外'}]}, {'label': '首次手术方式', 'keyword': 'method_of_first_surgery', 'type': 'select', 'placeholder': '请选择首次手术方式', 'option': [{'label': '', 'value': ''}, {'label': '截指/肢', 'value': '截指/肢'}, {'label': '扩大切除', 'value': '扩大切除'}, {'label': '转移灶切除', 'value': '转移灶切除'}, {'label': '淋巴结切除', 'value': '淋巴结切除'}, {'label': '淋巴结清扫', 'value': '淋巴结清扫'}, {'label': '切除未扩大', 'value': '切除未扩大'}]}, {'label': '首次手术Breslow厚度', 'keyword': 'breslow_thick_first_surg', 'type': 'number', 'placeholder': '请输入首次手术Breslow厚度（mm）'}, {'label': '再次术式', 'keyword': 'subsequent_surg_method', 'type': 'select', 'placeholder': '请选择再次术式', 'option': [{'label': '', 'value': ''}, {'label': '截指/肢', 'value': '截指/肢'}, {'label': '扩大切除', 'value': '扩大切除'}, {'label': '再扩大切除', 'value': '再扩大切除'}, {'label': '转移灶切除', 'value': '转移灶切除'}, {'label': '淋巴结切除', 'value': '淋巴结切除'}, {'label': '淋巴结清扫', 'value': '淋巴结清扫'}]}, {'label': '局部5cm内手术总次数', 'keyword': 'total_surg_cnt_local_5cm', 'type': 'number', 'placeholder': '请输入局部5cm内手术总次数'}, {'label': '术前活检', 'keyword': 'preoperative_biopsy', 'type': 'select', 'placeholder': '请选择术前活检', 'option': [{'label': '', 'value': ''}, {'label': '否', 'value': '否'}, {'label': '是', 'value': '是'}]}, {'label': '其它治疗史', 'keyword': 'other_treatment_history', 'type': 'select', 'placeholder': '请选择其它治疗史', 'option': [{'label': '', 'value': ''}, {'label': '无', 'value': '无'}, {'label': '激光治疗', 'value': '激光治疗'}, {'label': '自已乱治', 'value': '自已乱治'}, {'label': '放疗', 'value': '放疗'}, {'label': '化疗', 'value': '化疗'}, {'label': '其它', 'value': '其它'}]}, {'label': '最早发现转移部位', 'keyword': 'earliest_meta_site', 'type': 'select', 'placeholder': '请选择最早发现转移部位', 'option': [{'label': '', 'value': ''}, {'label': '无', 'value': '无'}, {'label': '淋巴结', 'value': '淋巴结'}, {'label': '肝', 'value': '肝'}, {'label': '肺', 'value': '肺'}, {'label': '其它', 'value': '其它'}]}, {'label': '最早发现转移时间', 'keyword': 'earliest_meta_time', 'type': 'date', 'placeholder': '请选择最早发现转移时间（年/月）'}, {'label': '现在转移部位', 'keyword': 'current_metastasis_site', 'type': 'select', 'placeholder': '请选择现在转移部位', 'option': [{'label': '', 'value': ''}, {'label': '无', 'value': '无'}, {'label': '淋巴结', 'value': '淋巴结'}, {'label': '肝', 'value': '肝'}, {'label': '肺', 'value': '肺'}, {'label': '其它', 'value': '其它'}]}, {'label': '现在转移发现时间', 'keyword': 'current_meta_discovery_time', 'type': 'date', 'placeholder': '请选择现在转移发现时间（年/月）'}, {'label': '前哨淋巴结阳性', 'keyword': 'sentinel_ln_positivity', 'type': 'select', 'placeholder': '请选择前哨淋巴结阳性', 'option': [{'label': '', 'value': ''}, {'label': '否', 'value': '否'}, {'label': '是', 'value': '是'}]}, {'label': '辅助治疗-化疗-状态', 'keyword': 'adj_tx_chemo_status', 'type': 'select', 'placeholder': '请选择辅助治疗-化疗-状态', 'option': [{'label': '', 'value': ''}, {'label': '否', 'value': '否'}, {'label': '西京', 'value': '西京'}, {'label': '院外', 'value': '院外'}]}, {'label': '辅助治疗-化疗-月数', 'keyword': 'adj_tx_chemo_months', 'type': 'number', 'placeholder': '请输入辅助治疗-化疗-月数'}, {'label': '辅助治疗-放疗-状态', 'keyword': 'adj_tx_radio_status', 'type': 'select', 'placeholder': '请选择辅助治疗-放疗-状态', 'option': [{'label': '', 'value': ''}, {'label': '否', 'value': '否'}, {'label': '西京', 'value': '西京'}, {'label': '院外', 'value': '院外'}]}, {'label': '辅助治疗-放疗-次数', 'keyword': 'adj_tx_radio_count', 'type': 'number', 'placeholder': '请输入辅助治疗-放疗-次数'}, {'label': '首次日期', 'keyword': 'ifn_alpha1b_initial_date', 'type': 'date', 'placeholder': '请选择干扰素-α1b首次日期'}, {'label': '剂量周期', 'keyword': 'ifn_alpha1b_dosage_cycle', 'type': 'input', 'placeholder': '请输入干扰素-α1b剂量周期（μg/月）'}, {'label': '不良反应-发热', 'keyword': 'ifn_alpha1b_ae_fever', 'type': 'select', 'placeholder': '请选择干扰素-α1b不良反应-发热', 'option': [{'label': '', 'value': ''}, {'label': '无', 'value': '无'}, {'label': '有', 'value': '有'}]}, {'label': '不良反应最高体温', 'keyword': 'ifn_alpha1b_ae_max_temp', 'type': 'number', 'placeholder': '请输入干扰素-α1b不良反应最高体温（℃）'}, {'label': '不良反应持续时间', 'keyword': 'ifn_alpha1b_ae_duration', 'type': 'input', 'placeholder': '请输入干扰素-α1b不良反应持续时间（h）'}, {'label': '不良反应后续发热情况', 'keyword': 'ifn_alpha1b_ae_subseq_fever', 'type': 'input', 'placeholder': '请输入干扰素-α1b不良反应后续发热情况'}, {'label': '首次日期', 'keyword': 'pd1_tx_initial_date', 'type': 'date', 'placeholder': '请选择PD-1治疗首次日期'}, {'label': '治疗剂量', 'keyword': 'pd1_tx_dosage', 'type': 'input', 'placeholder': '请输入PD-1治疗剂量（mg）'}, {'label': '治疗末次日期', 'keyword': 'pd1_tx_last_date', 'type': 'date', 'placeholder': '请选择PD-1治疗末次日期'}, {'label': '治疗总次数', 'keyword': 'pd1_tx_total_count', 'type': 'number', 'placeholder': '请输入PD-1治疗总次数'}, {'label': '日期', 'keyword': 'tmz_anlotinib_date', 'type': 'date', 'placeholder': '请选择TMZ/安罗替尼日期'}, {'label': '剂量', 'keyword': 'tmz_anlotinib_dosage', 'type': 'input', 'placeholder': '请输入TMZ/安罗替尼剂量（mg）'}, {'label': '末次日期', 'keyword': 'tmz_anlotinib_last_date', 'type': 'date', 'placeholder': '请选择TMZ/安罗替尼末次日期'}, {'label': '周期', 'keyword': 'tmz_anlotinib_cycle', 'type': 'input', 'placeholder': '请输入TMZ/安罗替尼周期（月）'}, {'label': '白癜风伴随分类', 'keyword': 'viti_concomitant_class', 'type': 'select', 'placeholder': '请选择白癜风伴随分类', 'option': [{'label': '', 'value': ''}, {'label': '患瘤前', 'value': '患瘤前'}, {'label': '治疗月开始', 'value': '治疗月开始'}]}, {'label': '白癜风伴随首发日期', 'keyword': 'viti_concomitant_onset_date', 'type': 'date', 'placeholder': '请选择白癜风伴随首发日期（年/月）'}, {'label': '白癜风伴随最重面积', 'keyword': 'viti_concomitant_max_area', 'type': 'input', 'placeholder': '请输入白癜风伴随最重面积（手掌数）'}, {'label': '白癜风伴随好转日期', 'keyword': 'viti_concomitant_impr_date', 'type': 'date', 'placeholder': '请选择白癜风伴随好转日期（年/月）'}, {'label': '血常规WBC', 'keyword': 'lab_blood_routine_wbc', 'type': 'number', 'placeholder': '请输入血常规WBC'}, {'label': '血常规RBC', 'keyword': 'lab_blood_routine_rbc', 'type': 'number', 'placeholder': '请输入血常规RBC'}, {'label': '血常规HB', 'keyword': 'lab_blood_routine_hb', 'type': 'number', 'placeholder': '请输入血常规HB'}, {'label': '血常规Plt', 'keyword': 'lab_blood_routine_plt', 'type': 'number', 'placeholder': '请输入血常规Plt'}, {'label': '肝功ALT', 'keyword': 'lab_liver_func_alt', 'type': 'number', 'placeholder': '请输入肝功ALT'}, {'label': '肝功AST', 'keyword': 'lab_liver_func_ast', 'type': 'number', 'placeholder': '请输入肝功AST'}, {'label': '肝功TBIL', 'keyword': 'lab_liver_func_tbil', 'type': 'number', 'placeholder': '请输入肝功TBIL'}, {'label': '甲功/免疫TSH', 'keyword': 'lab_thyroid_imm_tsh', 'type': 'number', 'placeholder': '请输入甲功/免疫TSH'}, {'label': '甲功/免疫antpo', 'keyword': 'lab_thyroid_imm_antpo', 'type': 'input', 'placeholder': '请输入甲功/免疫antpo'}, {'label': '甲功/免疫atg', 'keyword': 'lab_thyroid_imm_atg', 'type': 'input', 'placeholder': '请输入甲功/免疫atg'}, {'label': '激素皮质醇', 'keyword': 'lab_hormone_cortisol', 'type': 'number', 'placeholder': '请输入激素皮质醇'}, {'label': 'TMB', 'keyword': 'gene_mol_indicators_tmb', 'type': 'input', 'placeholder': '请输入基因与分子指标TMB'}, {'label': 'MSI', 'keyword': 'gene_mol_indicators_msi', 'type': 'input', 'placeholder': '请输入基因与分子指标MSI'}, {'label': 'EWSR1易位', 'keyword': 'gene_mol_indicators_ewsr1_trans', 'type': 'input', 'placeholder': '请输入基因与分子指标EWSR1易位'}, {'label': 'B-raf（%）', 'keyword': 'gene_mol_indicators_braf', 'type': 'input', 'placeholder': '请输入基因与分子指标B-raf（%）'}, {'label': 'C-Kit（%）', 'keyword': 'gene_mol_indicators_ckit', 'type': 'input', 'placeholder': '请输入基因与分子指标C-Kit（%）'}, {'label': 'N-Ras（%）', 'keyword': 'gene_mol_indicators_nras', 'type': 'input', 'placeholder': '请输入基因与分子指标N-Ras（%）'}, {'label': 'PD-L1（%）', 'keyword': 'gene_mol_indicators_pdl1', 'type': 'input', 'placeholder': '请输入基因与分子指标PD-L1（%）'}, {'label': '溃疡', 'keyword': 'ihc_pathology_ulcer', 'type': 'input', 'placeholder': '请输入免疫组化与病理溃疡'}, {'label': 'S100', 'keyword': 'ihc_pathology_s100', 'type': 'input', 'placeholder': '请输入免疫组化与病理S100'}, {'label': 'HMB45', 'keyword': 'ihc_pathology_hmb45', 'type': 'input', 'placeholder': '请输入免疫组化与病理HMB45'}, {'label': 'Prame', 'keyword': 'ihc_pathology_prame', 'type': 'input', 'placeholder': '请输入免疫组化与病理Prame'}, {'label': 'MelanA', 'keyword': 'ihc_pathology_melana', 'type': 'input', 'placeholder': '请输入免疫组化与病理MelanA'}, {'label': 'SOX10', 'keyword': 'ihc_pathology_sox10', 'type': 'input', 'placeholder': '请输入免疫组化与病理SOX10'}, {'label': 'Ki-67（%）', 'keyword': 'ihc_pathology_ki67', 'type': 'input', 'placeholder': '请输入免疫组化与病理Ki-67（%）'}, {'label': 'PHH3', 'keyword': 'ihc_pathology_phh3', 'type': 'input', 'placeholder': '请输入免疫组化与病理PHH3'}, {'label': '核分裂指数', 'keyword': 'ihc_patho_mitotic_index', 'type': 'input', 'placeholder': '请输入免疫组化与病理核分裂指数'}, {'label': 'VE-1', 'keyword': 'ihc_pathology_ve1', 'type': 'input', 'placeholder': '请输入免疫组化与病理VE-1'}, {'label': '微卫星灶', 'keyword': 'ihc_patho_microsat_lesions', 'type': 'input', 'placeholder': '请输入免疫组化与病理微卫星灶'}, {'label': '管腔内瘤', 'keyword': 'ihc_patho_intravasc_tumor', 'type': 'input', 'placeholder': '请输入免疫组化与病理管腔内瘤'}, {'label': 'LC活跃度', 'keyword': 'ihc_patho_lc_activity', 'type': 'select', 'placeholder': '请选择免疫组化与病理LC活跃度', 'option': [{'label': '', 'value': ''}, {'label': '活跃', 'value': '活跃'}, {'label': '不活跃', 'value': '不活跃'}]}, {'label': '诊疗记录', 'keyword': 'dx_tx_records', 'type': 'input', 'placeholder': '请输入诊疗记录（关键治疗过程、转移瘤B超、CT、MR、PET/CT、副反应、处理措施）'}, {'label': '备注1', 'keyword': 'note1', 'type': 'input', 'placeholder': '请输入备注1'}]。";
      let task = "\n请从下面一段文字中，提取符合标准化格式要求的格式化字段，输出JSON对象，确保输出的每个字段都符合指定的类型和格式要求。"
      task += "请严格按照字段要求填写数据，并确保数据的准确性和完整性。对于不确定和不准确的、或不存在的字段，将字段对应的数值设置为null或空字符串（根据字段类型）。"
      task += "请务必遵守数据的标准化格式，以便后续的数据分析和处理。输出的日期以'yyyy-mm-dd'格式呈现，数值字段请确保为数字类型，文本字段请确保为字符串类型。以下是需要提取的数据文本：";
      return role + message + task + text;
    },


  },
  created() {
    this.formData = this.genForms();
  }
};
</script>
<style lang="less">
.mmBasicInfoDialog {
  .el-dialog__title {
    color: #4da3c0 !important;
    font-size: 20px;
    font-weight: 600;
  }
  .el-dialog__close {
    color: #4da3c0 !important;
    font-size: 26px;
    font-weight: 700;
  }
  .el-dialog__body {
    padding: 0 20px 30px;
  }
  .el-dialog {
    margin-top: 0 !important;
  }
  .el-input__inner {
    border-radius: 8px;
    height: 46px;
    color: #6b6b6b;
    font-size: 18px;
  }
  .el-input__prefix {
    left: auto;
    right: 10px;
    i {
      font-size: 20px !important;
      color: #797979;
    }
  }
  .el-input--prefix .el-input__inner {
    padding-left: 15px;
  }
  .el-input__icon {
    line-height: 46px;
  }
  .el-input__suffix-inner {
    i {
      font-size: 18px !important;
      color: #797979 !important;
    }
  }
  .el-input__suffix {
    right: 10px !important;
  }
  .el-button--primary {
    border-radius: 6px;
  }
  .el-dialog__wrapper{
    display: block;
  }
}
</style>
<style lang="less" scoped>
.mmBasicInfoDialog {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;  
  .popTitleDialog {
    font-size: 16px;
    font-weight: 400;
    color: rgb(60, 60, 60);
    margin-bottom: 15px;
    margin-top: 15px;
    text-indent: 12px;
    .field-filled-badge {
      color: #ffffff;
      font-size: 16px;
      font-weight: bold;
      margin-left: 4px;
      background: #4da3c0;
      width: 40px;
      height: 24px;
      border-radius: 12px;
    }
  }
  .dialog {
    display: flex;
    align-items: center;    
    .navBorder {
      width: 100%;
      height: 2px;
      background: #4da3c0;
    }
  }
  .main {
    width: 100%;
    padding: 0 16px;
    box-sizing: border-box;
    overflow-y: auto;
    display: flex;
    .left {
      width: 78%;
      height: 100%;
      display: inline-block;
      .popInput {
        width: 240px;
        border: 1px solid #c0c0c0 !important;
        border-radius: 8px;
        height: 48px;
        box-sizing: border-box;
      }
      .popInput.el-date-editor {
        width: 240px !important;
        .el-input {
          width: 100% !important;
        }
      }
    }
    .right {
      width: 22%;
      min-width: 280px;
      margin-left: 12px;
      display: flex;
      flex-direction: column;
      border-left: 1px solid #e0e0e0;
      padding-left: 12px;
      .right-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 12px;
        margin-bottom: 8px;
        .right-title {
          font-size: 15px;
          font-weight: 600;
          color: #4da3c0;
        }
      }
      .right-input-area {
        min-height: 300px;
        max-height: 300px;
        margin-bottom: 8px;
        overflow-y: auto;
        .el-textarea__inner {
          border-radius: 8px;
          font-size: 14px;
          line-height: 1.6;
          height: 300px !important;
        }
      }
      .right-result-area {
        min-height: 280px;
        max-height: 280px;
        display: flex;
        flex-direction: column;
        .right-result-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 6px;
        }
        .right-result-title {
          font-size: 14px;
          font-weight: 600;
          color: #4da3c0;
        }
        .json-result {
          flex: 1;
          background: #f5f7fa;
          border: 1px solid #e0e0e0;
          border-radius: 8px;
          padding: 10px;
          font-size: 12px;
          line-height: 1.5;
          overflow-y: auto;
          white-space: pre-wrap;
          word-break: break-all;
          margin: 0;
          color: #333;
        }
      }
    }
  }
}
.dialog-footer{
  display: flex;
  justify-content: center;
  align-items: center;
}
.leftItemSubmit {
  width: 280px;
  height: 42px;
}
.required-star {
  color: #f56c6c;
  font-size: 16px;
  margin-left: 2px;
}
.required-error .el-input__inner,
.required-error .el-date-editor .el-input__inner,
.required-error .el-select .el-input__inner {
  border-color: #f56c6c !important;
}
.field-filled .el-input__inner,
.field-filled .el-date-editor .el-input__inner,
.field-filled .el-select .el-input__inner {
  border: 2px solid #52c41a !important;
  background-color: #f6ffed !important;
}
.field-filled .rightItemTitle {
  font-weight: 600 !important;
  color: #389e0d !important;
}
.section-stats {
  color: rgb(60, 60, 60);
  font-size: 16px;
  font-weight: 600;
  margin-left: 20px;
}
</style>
